import { UseFormReturn, useWatch } from "react-hook-form";

import { useTranslation } from "../../core/translation.core";
import useMaterialQuery from "../../hooks/useMaterialQuery";
import { ChevronSmallDownIcon, ChevronSmallUpIcon, ChevronUpDownIcon } from "../../icons/chevronUpDown.icon";
import ErrorCenterIcon from "../../icons/exclamationTriangleCenter.icon";
import LoadingOvalCenterIcon from "../../icons/loadingOvalCenter.icon";
import { MaterialListFilter, SortKey } from "../../types/material";
import MaterialListRow from "./materialListRow.comp";

export default function MaterialListComp({ methods }: { methods: UseFormReturn<MaterialListFilter, any> }) {
  const { t, msg } = useTranslation();
  const { data: materials, isFetched, isError, failureReason } = useMaterialQuery(methods);

  if (isError) return <ErrorCenterIcon reason={failureReason} />;
  if (!isFetched) return <LoadingOvalCenterIcon />;

  return (
    <div id="product-section" className="pt-6 lg:pt-0">
      <div className="hidden lg:grid lg:grid-cols-[1fr_4fr_2fr_1fr_2fr] gap-6 px-6 py-3 text-sm font-medium">
        <div>{t(msg.product.image)}</div>
        <Title title={t(msg.material.materialDetail)} name="name" methods={methods} />
        <Title title={t(msg.product.sku)} name="sku" methods={methods} />
        {/* <Title title={t(msg.product.price2)} name="price" methods={methods} />
        <div className="flex items-center gap-2">{t(msg.category.category)}</div> */}
      </div>

      {materials?.list.map((p) => (
        <MaterialListRow material={p} key={p.id} />
      ))}
    </div>
  );
}

function Title({ methods, title, name }: { methods: UseFormReturn<MaterialListFilter, any>; title: string; name: SortKey }) {
  const [sort, isSortAsec] = useWatch({
    name: ["sort", "sortAsec"],
    control: methods.control,
  });

  function click() {
    methods.setValue("sort", name);
    methods.setValue("sortAsec", sort !== name ? 1 : isSortAsec === 1 ? -1 : 1);
  }

  return (
    <button id={`sort_${name}`} className="flex items-center gap-2" onClick={click}>
      {title}
      {sort !== name && <ChevronUpDownIcon />}
      {sort === name && isSortAsec === 1 && <ChevronSmallUpIcon />}
      {sort === name && isSortAsec === -1 && <ChevronSmallDownIcon />}
    </button>
  );
}
